
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.5.2 (99337d87ab1cca2641a1b99779d5ab74)",
    buildSeed: 1790942712518,
    "wdosbox-x-jspi.wasm": {
        "size": 7893150,
        "gzSize": 2744477
    },
    "wdosbox-x-jspi.js": {
        "size": 249370,
        "gzSize": 59349
    },
    "wdosbox-x.wasm": {
        "size": 8045933,
        "gzSize": 2797906
    },
    "wdosbox-x.js": {
        "size": 248464,
        "gzSize": 60249
    },
    "wdosbox.wasm": {
        "size": 1459535,
        "gzSize": 501358
    },
    "wdosbox.js": {
        "size": 113486,
        "gzSize": 30075
    },
    "wlibzip.wasm": {
        "size": 112483,
        "gzSize": 52219
    },
    "wlibzip.js": {
        "size": 72957,
        "gzSize": 19326
    }
,
};
